import { faPen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LogicOperator, Role } from '@okletsplay/core';
import { withRoles } from 'shared/HOC/withRoles';
import { useStyles } from './EditGameButton.styles';
import React, { FC, memo, useCallback } from 'react';

interface EditGameButtonProps {
  onClick: () => void;
}

export const EditGameButtonComponent: FC<EditGameButtonProps> = ({ onClick }) => {
  const { classes } = useStyles();

  const onClickHandler = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      onClick();
    },
    [onClick]
  );

  return (
    <div className={classes.submenuNavLink} onClick={onClickHandler}>
      <FontAwesomeIcon className={classes.editGameIcon} icon={faPen} />
    </div>
  );
};

export const EditGameButton = memo(
  withRoles(EditGameButtonComponent, [Role.GameAdministrator], LogicOperator.OR)
);
